import _ from 'lodash';
function setSrc(s,a) {
   return  a ? a : s;
}

function isEmptyObject(value) {
  return value && Object.keys(value).length === 0 && value.constructor === Object;
}
function leadingZero(str) {
  let o = str;
  if (parseInt(str) < 10) o = '0' + str;
  return o;
}

function checkMessage(str) {
  let pattern = /{+?.+}+?/gm;
  return pattern.test(str);

}

function generateGuid() { // Public Domain/MIT
  var d = new Date().getTime();//Timestamp
  var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16;//random number between 0 and 16
      if(d > 0){//Use timestamp until depleted
          r = (d + r)%16 | 0;
          d = Math.floor(d/16);
      } else {//Use microseconds since page-load if supported
          r = (d2 + r)%16 | 0;
          d2 = Math.floor(d2/16);
      }
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}
function setTimestamp() {
  let now = new Date(Date.now());
  return `${leadingZero(now.getHours())}:${leadingZero(now.getMinutes())}:${leadingZero(now.getSeconds())}`;
}

function debugMode() {
  let urlParams = new URLSearchParams(window.location.search);
  return urlParams.has("debug");

}

function getIndex(array, guid) {
  return array.findIndex( element => {
    if (element.message.guid === guid) return true;
  })
}

function sortMessages(arr) {
  let messages = [...arr];
  let sos = _.sortBy(messages.filter( m => {
    return m.message.sos == 1;
  }), s => {
    return s.message.timestamp;
  });
  let unconf = _.sortBy(messages.filter( m => {
    return m.message.confirmed == 0;
  }), s => {
    return s.message.timestamp;
  });
  let conf = _.sortBy(messages.filter( m => {
    return m.message.confirmed == 1;
  }), s => {
    return s.message.timestamp;
  });

  return sos.reverse().concat(unconf.reverse(),conf.reverse());

}
function sendKAmessage(s) {
  (function send() {
    setTimeout(() => {
      let now = new Date(Date.now()).toISOString();
      let msg = JSON.stringify({"action": "sendmessage", "data": `ping at ${now}`});

      s.send(msg)
      send();
    }, 30000);
  })();
}

function humanReadableMessage(staff, room) {
  let message = {
    "message": `${staff.name} in ${room.name}`
  };
  if (staff.hasOwnProperty("notifications") && staff.notifications.length) {
    let providers = staff.notifications;
    let pdata = [];
    for(let i = 0; i < providers.length; i++) {
      pdata.push(providers[i]);
    }
    message.providers = pdata;
  }
  return message;
}
function buildMessage(msg) {
  if (!msg.hasOwnProperty("timestamp")) msg.timestamp = setTimestamp();
  if (!msg.hasOwnProperty("guid")) msg.guid = generateGuid();
  msg.infos = getUserData();
  return JSON.stringify(msg);

  // JSON.stringify({
  //   "action": "sendmessage",
  //   "data": JSON.stringify(msg)
  // });
}
function getUserData() {
  let ua = navigator.userAgent;
  let origin = document.location.origin;
  return [
    {"ua": ua},
    {"origin": origin},
    {"now": Date.now()}
  ];

}
export {
  setSrc,
  isEmptyObject,
  checkMessage,
  setTimestamp,
  generateGuid,
  getIndex,
  debugMode,
  sendKAmessage,
  sortMessages,
  buildMessage,
  humanReadableMessage
}